import { defineStyle, defineStyleConfig } from "@chakra-ui/react";

const brandColor = "brand.500";
const purpleColor = "purple.500";

const baseStyle = defineStyle({
  control: {
    width: "20px",
    height: "20px",
    boxSizing: "border-box",
    border: "1px solid",
    backgroundColor: "white",

    _checked: {
      borderWidth: "1px",
      backgroundColor: "white",

      _before: {
        display: "block",
        width: "10px",
        height: "10px",
      },

      _hover: {
        backgroundColor: "white",
      },
    },
  },
});

const brand = defineStyle({
  control: {
    borderColor: brandColor,
    _checked: {
      borderColor: brandColor,
      _before: { backgroundColor: brandColor },
      _hover: { borderColor: brandColor } },
  },
});

const purple = defineStyle({
  control: {
    borderColor: purpleColor,
    _checked: {
      borderColor: purpleColor,
      _before: { backgroundColor: purpleColor },
      _hover: { borderColor: purpleColor } },
  },
});

export const Radio = defineStyleConfig({
  baseStyle,
  variants: {
    brand,
    purple,
  },

  defaultProps: {
    variant: "brand",
  },
});
